<template>
  <FieldsIHMaintenanceModalComponent :flag-types="flagTypes" :event="event">
    <template #trailing>
      <EventActionFieldRowComponent>
        <FMFileInlineUploadPreview
          v-model:files-ids="event.fileIds"
          :disabled="disableEvent"
          automatic-screenshot
        />
      </EventActionFieldRowComponent>
    </template>
  </FieldsIHMaintenanceModalComponent>
</template>

<script lang="ts">
import { computed, defineComponent, inject, type PropType } from "vue";
import { useStore } from "vuex";
import { FlagTypes } from "@/graphql";
import {
  CreateInjectionKey,
  DisableEventInjectionKey,
} from "@/components/event-action/issue/IssueTypes";
import FieldsIHMaintenanceModalComponent from "./FieldsIHMaintenanceModalComponent.vue";
import injectAsserted from "@/functions/assert/injectAsserted";
import EventActionFieldRowComponent from "@/components/event-action/EventActionFieldRowComponent.vue";
import { type IHMaintenanceEditType } from "@/components/event-action/event/modal/EventEditType";
import FMFileInlineUploadPreview from "@/modules/filemanagement/components/FMFileInlineUploadPreview.vue";

export default defineComponent({
  name: "IHMaintenanceModalComponent",
  components: {
    FieldsIHMaintenanceModalComponent,
    EventActionFieldRowComponent,
    FMFileInlineUploadPreview,
  },
  props: {
    event: {
      type: Object as PropType<IHMaintenanceEditType>,
      required: true,
    },
    excludeFromSearch: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    flagTypes: {
      type: Array as PropType<FlagTypes[]>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const disableEvent = injectAsserted(DisableEventInjectionKey);
    const create = inject(CreateInjectionKey);

    const ownIssue = computed(() => {
      return store.getters["login/userId"] === props.event.owner?.id;
    });
    const hasIssueChangeRight = computed(() => {
      return store.getters["login/hasAccessRight"]("sqdc.issueChange");
    });
    const disableField = computed(() => {
      return !create?.value && !hasIssueChangeRight.value && !ownIssue.value;
    });

    const disable = computed(() => {
      return {
        description: disableField.value,
        creator: disableField.value,
        date: disableField.value,
        flags: disableField.value,
      };
    });

    return {
      disable,
      disableEvent,
    };
  },
});
</script>

<style lang="scss" scoped></style>
